import { appFormUtil } from 'modules/common';
import React from 'react';
import * as types from './types';



export type IFormState = {
  email: string;
  loading: boolean;
  password: string;
  confirmationCode: string;
  newPassword: string;
  confirmPassword: string;
  authState: types.IAuthState;
};

const initialState: IFormState = {
  email: '',
  loading: false,
  password: '',
  newPassword: '',
  confirmationCode: '',
  confirmPassword: '',
  authState: 'NOT_STARTED'
};

export function useFormState() {
  const {
    formState,
    dispatch,
    genFieldProps
  } = appFormUtil.useFormState({
    initialState,
    key2FieldConfig: {
      email: {
        label: 'Email',
        type: 'email',
        required: true
      },
      loading: {
        label: 'loading',
        type: 'text'
      },
      password: {
        label: 'Password',
        type: 'password',
        required: true
      },
      newPassword: {
        label: 'New Password',
        type: 'password',
        required: true
      },
      confirmPassword: {
        label: 'Confirm Password',
        type: 'password',
        required: true
      },
      confirmationCode: {
        label: 'Confirmation Code',
        type: 'text',
        required: true
      },
      authState: {
        label: 'Auth State',
        type: 'text',
        required: true
      }
    }
  });

  return React.useMemo(
    () => {


      return {
        formState,
        dispatch,
        genFieldProps
      };
    },
    [
      dispatch,
      formState,
      genFieldProps
    ]
  );
}
